import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetWalletStatisticsRequestSchema,
  TGetWalletStatisticsResponseSchema,
} from "./getWalletStatistics.schema";

export const getWalletStatistics = (axios: IAxiosInstance) => {
  return async (params: TGetWalletStatisticsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetWalletStatisticsResponseSchema>
    >(`/api/wallets/statistics`, { params });

    return response.data;
  };
};
